import React from 'react';
import { FiX } from 'react-icons/fi';

const PortfolioModal = ({ isOpen, onClose, project }) => {
  if (!isOpen) return null;

  console.log(project);

  return (
    <div className="rn-popup-modal portfolio-modal-wrapper">
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={onClose}>
              <FiX />
            </button>
          </div>
          <div className="modal-body">
            <div className="portfolio-modal">
              <div className={`thumbnail ${project.image}`}>
                <div className="thumbnail-inner"></div>
              </div>
              <div className="content">
                <h3>{project.title}</h3>
                <p className="category">{project.category}</p>
                <p className="description">{project.description}</p>
                {project.link && (
                  <a href={project.link} target="_blank" rel="noopener noreferrer" className="rn-btn">
                    Visitar Site
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioModal; 